//import components
import Breadcrumb from './../components/dynamic/Breadcrumb';
import ProfileSidebar from '../components/dynamic/profile/Sidebar';
import Profiles from '../components/dynamic/profile/Profiles';

//import locales
import { useTranslation } from "react-i18next";
import "../i18n";

export default function Profile() {

    //get locale
    const { t } = useTranslation();

    return (
        <>
            <Breadcrumb title={t('profile')} />
            <div className='container mx-auto mt-10 px-3'>
                <div className="grid grid-cols-12 gap-5">
                    <div className="col-span-3 gap-5">
                        <ProfileSidebar />
                    </div>
                    <div className="col-span-9 gap-5 grid-cols-12 grid">
                        <Profiles />
                    </div>
                </div>
            </div>
        </>
        
    );
}